import { useNavigate } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Theme, SxProps } from "@mui/material";

const BackButton = ({ sx }: { sx?: SxProps<Theme> }) => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  return (
    <IconButton sx={sx} onClick={goBack}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackButton;
